var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomClientOfferStage3MainIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 143,
  height: 143,
  viewBox: "0 0 143 143",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 71.5,
  r: 69.5,
  fill: "white",
  stroke: "url(#paint0_linear_5261_1434)",
  strokeWidth: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M104.919 80.4716C101.182 76.0029 96.7085 71.9895 91.3188 68.2492C84.1646 63.2843 76.1918 59.376 68.5006 55.6058C60.8705 51.8708 52.9765 48.0028 45.9377 43.118C40.6922 39.4778 36.3048 35.5456 32.68 31.2123L31.7989 30.193L8.41796 63.8843L8.96122 64.4975C12.6986 68.9662 17.1688 72.9844 22.5585 76.7247C29.7127 81.6896 37.6855 85.5979 45.3718 89.3648C53.002 93.0998 60.896 96.9678 67.93 101.849C73.1754 105.489 77.5677 109.425 81.1924 113.758L82.0783 114.781L105.463 81.0847L104.915 80.4682L104.919 80.4716ZM77.2324 103.503C59.0785 88.5213 35.5061 83.606 17.4427 68.4941C17.5179 68.396 17.6013 68.2964 17.675 68.1901C19.6025 65.4127 19.0802 61.1356 16.8754 58.4104C16.8167 58.341 16.6393 58.1964 16.6527 58.1771L27.7817 42.1405C28.1183 42.6819 28.761 43.2853 29.3254 43.6627C30.6326 44.5197 32.228 44.6536 33.6266 44.0855C34.7138 43.6377 35.6552 42.7738 36.312 41.6838C54.3588 56.6554 77.8218 61.5949 95.9136 76.5119C95.5573 76.9946 95.263 77.5418 95.0423 78.1472C94.6578 79.2043 94.5288 80.3243 94.6376 81.5019C94.7464 82.6795 95.0841 83.7942 95.6267 84.8291C95.9597 85.4681 96.3593 86.0317 96.7929 86.5258C93.0284 91.9503 89.2607 97.3795 85.4962 102.804C85.4693 102.771 85.4409 102.73 85.4173 102.692C83.1645 99.9333 79.3969 100.353 77.4359 103.179C77.3622 103.285 77.298 103.398 77.2291 103.508L77.2324 103.503Z",
  fill: "url(#paint1_linear_5261_1434)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M85.4175 102.693C85.4444 102.726 85.4728 102.767 85.4964 102.805C89.2609 97.3801 93.0286 91.9509 96.7931 86.5264C96.3513 86.0338 95.9599 85.4688 95.6269 84.8297C95.0843 83.7948 94.7466 82.6801 94.6378 81.5025C94.529 80.3249 94.6613 79.2001 95.0425 78.1479C95.2632 77.5424 95.5623 76.9985 95.9186 76.5159C77.8316 61.6022 54.37 56.6708 36.3266 41.6944C35.6746 42.7878 34.7395 43.6632 33.6556 44.1061C32.2618 44.6775 30.6424 44.527 29.3304 43.6666C28.7626 43.2941 28.12 42.6906 27.7867 42.1444L16.6577 58.1811C16.6577 58.1811 16.8265 58.3483 16.8804 58.4144C19.0818 61.1444 19.5834 65.4 17.656 68.1774C17.5822 68.2837 17.5085 68.3899 17.4381 68.4914C35.5015 83.6033 59.0787 88.5219 77.2326 103.503C77.3016 103.394 77.3657 103.281 77.4395 103.175C79.4004 100.349 83.1728 99.9325 85.4257 102.691L85.4175 102.693ZM34.4228 64.813C32.9883 63.9034 32.6481 61.9711 33.6236 60.5655C34.599 59.1599 36.5099 58.8185 37.9459 59.7363C39.3804 60.646 39.7862 62.4734 38.8141 63.8742C37.842 65.275 35.8574 65.7226 34.4228 64.813ZM49.0645 83.4903C42.7564 80.8374 42.039 72.8895 45.8282 67.6039C49.9339 61.8724 57.7522 58.9106 64.2328 61.6332C70.541 64.2861 71.2699 72.2277 67.4841 77.5084C63.3783 83.2399 55.55 86.2162 49.0645 83.4903ZM75.3816 85.3437C73.9438 84.4389 73.5313 82.6211 74.5034 81.2203C75.4755 79.8195 77.4635 79.367 78.9047 80.267C80.3426 81.1718 80.6895 83.0944 79.7174 84.4952C78.7453 85.896 76.8277 86.247 75.385 85.3388L75.3816 85.3437Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.549 68.6811C56.3144 69.0193 56.3102 69.3742 56.4049 69.6689C56.4996 69.9636 56.7349 70.2199 57.2324 70.5295L58.7811 68.2979C58.2366 68.056 57.887 68.0567 57.4983 68.1447C57.1177 68.2313 56.7569 68.3817 56.5457 68.686L56.549 68.6811Z",
  fill: "url(#paint2_linear_5261_1434)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M56.4272 73.7421L54.7746 76.1234C55.3191 76.3653 55.7999 76.4628 56.182 76.3844C56.564 76.3061 56.9243 76.1052 57.1857 75.7284C57.4472 75.3517 57.483 74.9614 57.3801 74.6682C57.2821 74.3783 56.9266 74.0386 56.419 73.7436L56.4272 73.7421Z",
  fill: "url(#paint3_linear_5261_1434)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M67.4804 77.512C63.3699 83.2401 55.5463 86.2198 49.0643 83.489C42.7561 80.8361 42.0387 72.8882 45.8279 67.6026C49.9336 61.8712 57.7486 58.9142 64.2292 61.6367C70.5407 64.2849 71.2696 72.2264 67.4804 77.512Z",
  fill: "url(#paint4_linear_5261_1434)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9458 59.7359C36.5113 58.8262 34.5956 59.1642 33.6235 60.565C32.6514 61.9658 32.9868 63.8947 34.4228 64.8125C35.8573 65.7222 37.8419 65.2745 38.814 63.8737C39.7862 62.4729 39.3804 60.6455 37.9458 59.7359Z",
  fill: "url(#paint5_linear_5261_1434)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M78.9045 80.2673C77.4667 79.3625 75.4787 79.815 74.5032 81.2206C73.5277 82.6262 73.9402 84.444 75.3815 85.344C76.8193 86.2488 78.7418 85.9011 79.7139 84.5003C80.686 83.0995 80.3472 81.1755 78.9012 80.2722L78.9045 80.2673Z",
  fill: "url(#paint6_linear_5261_1434)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1512 71.2339L50.6709 66.1621L52.8489 67.6736C53.1662 67.8938 53.3972 68.1614 53.5418 68.4765C53.6913 68.7949 53.751 69.1298 53.7209 69.481C53.6956 69.8357 53.5741 70.1699 53.3562 70.4839C53.1282 70.8124 52.8492 71.0553 52.5192 71.2127C52.1973 71.3686 51.8594 71.4347 51.5054 71.4109C51.1563 71.3905 50.8231 71.2702 50.5058 71.05L49.5538 70.3893L48.3772 72.0848L47.1512 71.2339ZM50.2814 69.2947L51.0819 69.8503C51.1876 69.9237 51.3022 69.9638 51.4257 69.9708C51.5491 69.9777 51.6691 69.9536 51.7856 69.8985C51.9022 69.8435 52.0024 69.7556 52.0862 69.6348C52.1734 69.5092 52.2207 69.3846 52.2281 69.2609C52.2356 69.1373 52.2128 69.0213 52.1598 68.9129C52.1067 68.8046 52.0274 68.7137 51.9216 68.6403L51.1211 68.0847L50.2814 69.2947Z",
  fill: "white"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M51.782 74.4476L55.3017 69.3758L56.5277 70.2266L53.7622 74.2116L56.0124 75.7731L55.2581 76.86L51.782 74.4476Z",
  fill: "white"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0325 77.3973L59.5522 72.3255L60.6484 73.0863L60.7811 78.5458L60.5683 78.3444C60.6548 78.1683 60.7412 78.0028 60.8273 77.8479C60.9135 77.693 60.9979 77.5405 61.0807 77.3904C61.1683 77.2436 61.2576 77.0945 61.3485 76.9429C61.4443 76.7946 61.5484 76.6343 61.6609 76.4619C61.7783 76.2929 61.9057 76.1093 62.0431 75.9113L62.913 74.6578L64.1029 75.4836L60.5832 80.5554L59.4726 79.7847L59.305 74.1292L59.6376 74.4351C59.5007 74.6837 59.3825 74.895 59.283 75.0693C59.1916 75.242 59.1071 75.3945 59.0296 75.5268C58.9568 75.6624 58.8877 75.7826 58.8221 75.8874C58.7565 75.9921 58.6885 76.0952 58.6181 76.1967C58.5559 76.2966 58.4829 76.407 58.3991 76.5277L57.2225 78.2232L56.0325 77.3973Z",
  fill: "white"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M112.953 98.1198C112.274 92.334 110.73 86.5257 108.27 80.4441C105.005 72.3714 100.476 64.7341 96.1063 57.3667C91.7689 50.0622 87.2836 42.5019 84.0707 34.5594C81.6764 28.6405 80.1598 22.9473 79.5011 17.3365L79.3224 16.001L41.3055 31.3795L41.4241 32.1901C42.1029 37.9759 43.6416 43.7864 46.1017 49.868C49.3672 57.9407 53.8964 65.578 58.2634 72.94C62.6008 80.2445 67.0861 87.8048 70.2968 95.7419C72.6911 101.661 74.2098 107.359 74.8686 112.97L75.0495 114.311L113.072 98.9304L112.951 98.1144L112.953 98.1198ZM77.1735 102.221C70.1926 79.7428 53.1643 62.7177 46.3305 40.1798C46.4472 40.1389 46.5715 40.1013 46.6914 40.0528C49.8254 38.785 51.7314 34.9206 51.3797 31.4329C51.3686 31.3428 51.2994 31.1246 51.3212 31.1157L69.4167 23.7958C69.4018 24.4331 69.6088 25.29 69.8743 25.9149C70.4984 27.348 71.7598 28.3339 73.2411 28.6248C74.396 28.8458 75.6568 28.6387 76.8034 28.0866C83.7001 50.498 100.624 67.4834 107.588 89.8738C107.025 90.0824 106.479 90.379 105.963 90.7646C105.062 91.4384 104.341 92.3047 103.787 93.3495C103.233 94.3943 102.905 95.5118 102.792 96.6749C102.72 97.3919 102.746 98.0823 102.838 98.7332C96.7171 101.209 90.5908 103.687 84.47 106.163C84.4655 106.121 84.4643 106.071 84.4653 106.026C84.0917 102.484 80.7097 100.772 77.5212 102.062C77.4013 102.11 77.2858 102.169 77.1681 102.223L77.1735 102.221Z",
  fill: "url(#paint7_linear_5261_1434)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M84.4655 106.026C84.47 106.068 84.4712 106.118 84.4702 106.163C90.591 103.687 96.7173 101.208 102.838 98.7324C102.738 98.0783 102.721 97.3911 102.792 96.6741C102.905 95.511 103.233 94.3935 103.787 93.3487C104.341 92.3038 105.068 91.4353 105.963 90.7638C106.48 90.3782 107.028 90.087 107.59 89.8784C100.628 67.4935 83.7015 50.5156 76.8102 28.102C75.6658 28.6596 74.4039 28.8797 73.2545 28.6565C71.7754 28.371 70.503 27.358 69.8767 25.9195C69.6058 25.2968 69.3987 24.4399 69.4191 23.8004L51.3236 31.1203C51.3236 31.1203 51.3732 31.3528 51.3822 31.4375C51.7284 34.9274 49.8168 38.7625 46.6828 40.0302C46.5629 40.0787 46.443 40.1272 46.3285 40.1735C53.1623 62.7114 70.1928 79.742 77.1737 102.22C77.2915 102.166 77.407 102.107 77.5269 102.059C80.7154 100.769 84.0995 102.487 84.4732 106.029L84.4655 106.026ZM62.5532 46.4004C61.8513 44.8536 62.6252 43.0507 64.2112 42.4091C65.7973 41.7675 67.583 42.5287 68.2816 44.0832C68.9834 45.63 68.3219 47.3812 66.7412 48.0206C65.1606 48.6599 63.255 47.9472 62.5532 46.4004ZM64.5712 70.0467C60.747 64.3717 64.5006 57.3294 70.5661 54.9831C77.1407 52.4372 85.3041 54.2422 89.2344 60.07C93.0586 65.7451 89.318 72.7883 83.258 75.1324C76.6834 77.6783 68.5037 75.88 64.5712 70.0467ZM85.5731 86.0137C84.8658 84.4691 85.5164 82.7223 87.0971 82.0829C88.6777 81.4436 90.5887 82.154 91.3015 83.6965C92.0088 85.2411 91.2458 87.0396 89.6652 87.679C88.0846 88.3184 86.288 87.5616 85.5785 86.0115L85.5731 86.0137Z",
  fill: "white"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M78.9449 61.7594C78.5634 61.9137 78.3654 62.2084 78.2832 62.5068C78.201 62.8052 78.2574 63.1485 78.5041 63.68L81.0222 62.6614C80.6992 62.1608 80.4063 61.9699 80.0329 61.8306C79.667 61.6945 79.2828 61.6227 78.9394 61.7616L78.9449 61.7594Z",
  fill: "url(#paint8_linear_5261_1434)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M76.0703 65.9263L73.3832 67.0132C73.7062 67.5139 74.0551 67.8589 74.4176 68.0026C74.7802 68.1463 75.1916 68.1756 75.6168 68.0036C76.0419 67.8316 76.2856 67.5247 76.3602 67.2231C76.437 66.9269 76.3257 66.4479 76.0626 65.9231L76.0703 65.9263Z",
  fill: "url(#paint9_linear_5261_1434)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M83.2521 75.1358C76.6754 77.6763 68.4979 75.8834 64.5708 70.0479C60.7466 64.3729 64.5002 57.3306 70.5657 54.9843C77.1403 52.4384 85.2982 54.2456 89.2286 60.0734C93.0582 65.7462 89.3176 72.7895 83.2521 75.1358Z",
  fill: "url(#paint10_linear_5261_1434)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M68.2812 44.0832C67.5793 42.5364 65.7914 41.7697 64.2108 42.4091C62.6302 43.0485 61.8542 44.846 62.5527 46.4005C63.2546 47.9473 65.1602 48.66 66.7408 48.0206C68.3214 47.3812 68.983 45.6301 68.2812 44.0832Z",
  fill: "url(#paint11_linear_5261_1434)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M91.3011 83.6978C90.5938 82.1532 88.6828 81.4427 87.0967 82.0843C85.5106 82.7259 84.8599 84.4726 85.5727 86.0151C86.28 87.5597 88.0787 88.3219 89.6594 87.6825C91.24 87.0432 92.0106 85.2479 91.2956 83.7L91.3011 83.6978Z",
  fill: "url(#paint12_linear_5261_1434)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M69.6838 58.7467L75.4067 56.4316L76.4009 58.8893C76.5457 59.2473 76.5924 59.5978 76.5408 59.9406C76.4914 60.2888 76.3579 60.6017 76.1403 60.8791C75.9249 61.1619 75.6401 61.375 75.2858 61.5183C74.9152 61.6682 74.5487 61.7186 74.1863 61.6695C73.8316 61.6236 73.5127 61.4938 73.2296 61.28C72.9487 61.0717 72.7359 60.7885 72.591 60.4304L72.1565 59.3562L70.2434 60.1301L69.6838 58.7467ZM73.3648 58.839L73.7302 59.7423C73.7785 59.8617 73.8523 59.9581 73.9518 60.0315C74.0513 60.1049 74.1648 60.1505 74.2925 60.1682C74.4202 60.186 74.5522 60.1674 74.6885 60.1122C74.8302 60.0549 74.938 59.9766 75.012 59.8772C75.086 59.7778 75.1304 59.6683 75.1455 59.5486C75.1605 59.4289 75.1438 59.3094 75.0955 59.19L74.7301 58.2867L73.3648 58.839Z",
  fill: "white"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M71.7975 63.972L77.5205 61.657L78.0801 63.0404L73.5835 64.8594L74.6106 67.3984L73.3842 67.8944L71.7975 63.972Z",
  fill: "white"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M73.7377 68.7682L79.4606 66.4532L79.961 67.6901L77.0813 72.3303L77.0135 72.0452C77.1824 71.9453 77.3453 71.8542 77.5023 71.7718C77.6592 71.6894 77.8134 71.608 77.9649 71.5278C78.1186 71.453 78.275 71.3771 78.4341 71.3001C78.5954 71.2286 78.7703 71.1515 78.9589 71.0689C79.1497 70.9917 79.3568 70.9079 79.5803 70.8176L80.9947 70.2454L81.5378 71.5881L75.8149 73.9032L75.3079 72.65L78.2658 67.8267L78.3764 68.2649C78.1258 68.3978 77.9111 68.5099 77.7323 68.6011C77.5613 68.6956 77.4071 68.7769 77.2697 68.8451C77.1346 68.9187 77.0109 68.9814 76.8986 69.0331C76.7864 69.0848 76.673 69.1338 76.5586 69.1801C76.4517 69.2296 76.3302 69.282 76.1939 69.3371L74.2808 70.111L73.7377 68.7682Z",
  fill: "white"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M114.876 115.402C116.637 109.849 117.618 103.92 117.878 97.3649C118.222 88.6635 117.235 79.8393 116.283 71.3268C115.334 62.8848 114.355 54.1487 114.693 45.5877C114.946 39.2078 115.905 33.3948 117.612 28.0096L117.999 26.7188L77.0213 25.0989L76.796 25.8866C75.0349 31.4395 74.0473 37.3686 73.7882 43.9238C73.4442 52.6252 74.4311 61.4494 75.3835 69.9561C76.3325 78.3981 77.3111 87.1342 76.9729 95.6894C76.7207 102.069 75.761 107.888 74.0536 113.273L73.6669 114.57L114.65 116.19L114.876 115.397L114.876 115.402ZM80.5758 104.424C83.4586 81.0636 74.9403 58.5412 77.9818 35.1872C78.1049 35.1979 78.2337 35.2148 78.3629 35.2199C81.741 35.3534 85.0678 32.6151 86.1819 29.2914C86.2088 29.2046 86.2355 28.9773 86.259 28.9782L105.764 29.7492C105.488 30.324 105.324 31.1902 105.309 31.869C105.289 33.432 106.033 34.8494 107.263 35.7239C108.225 36.4003 109.459 36.7302 110.732 36.6985C107.8 59.9631 116.239 82.4062 113.377 105.679C112.779 105.638 112.159 105.684 111.53 105.823C110.431 106.067 109.418 106.56 108.483 107.284C107.548 108.008 106.789 108.892 106.208 109.906C105.848 110.53 105.587 111.17 105.403 111.801C98.8059 111.54 92.2025 111.279 85.6049 111.018C85.6183 110.978 85.6378 110.932 85.657 110.891C86.7734 107.509 84.3952 104.557 80.9584 104.421C80.8291 104.416 80.6994 104.423 80.5699 104.424L80.5758 104.424Z",
  fill: "url(#paint13_linear_5261_1434)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M85.657 110.892C85.6436 110.933 85.6242 110.979 85.6049 111.019C92.2024 111.28 98.8058 111.541 105.403 111.802C105.582 111.165 105.848 110.531 106.208 109.907C106.789 108.893 107.548 108.009 108.483 107.285C109.418 106.561 110.437 106.068 111.53 105.824C112.159 105.685 112.778 105.645 113.377 105.686C116.238 82.4189 107.793 59.9814 110.731 36.717C109.459 36.7546 108.218 36.4361 107.262 35.7599C106.031 34.8913 105.288 33.4446 105.309 31.8758C105.318 31.1968 105.482 30.3306 105.763 29.756L86.2587 28.985C86.2587 28.985 86.2084 29.2173 86.1816 29.2982C85.0617 32.6216 81.7419 35.331 78.3638 35.1974C78.2346 35.1923 78.1053 35.1872 77.982 35.1823C74.9405 58.5363 83.4586 81.0645 80.5758 104.425C80.7053 104.424 80.835 104.417 80.9642 104.423C84.4011 104.558 86.779 107.516 85.6626 110.898L85.657 110.892ZM90.2093 47.5316C90.2059 45.833 91.6528 44.508 93.3624 44.5756C95.072 44.6431 96.3865 46.0715 96.3839 47.7757C96.3873 49.4743 95.064 50.7984 93.3603 50.731C91.6566 50.6637 90.2128 49.2302 90.2093 47.5316ZM82.3224 69.9151C81.171 63.1693 87.4891 58.2944 93.9828 58.6506C101.023 59.0343 107.721 64.0373 108.906 70.9659C110.058 77.7117 103.751 82.5929 97.2634 82.2369C90.2236 81.8532 83.5076 76.8495 82.3224 69.9151ZM94.8979 93.1074C94.8885 91.4085 96.2001 90.084 97.9038 90.1514C99.6075 90.2187 101.057 91.6524 101.072 93.3515C101.082 95.0503 99.6466 96.3758 97.9428 96.3084C96.2391 96.2411 94.9128 94.8123 94.9037 93.1076L94.8979 93.1074Z",
  fill: "white"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8332 68.2713C98.422 68.255 98.1204 68.4422 97.9227 68.6804C97.7249 68.9186 97.6352 69.2547 97.6414 69.8407L100.356 69.948C100.267 69.3588 100.079 69.0643 99.7956 68.7837C99.5181 68.5092 99.1975 68.2857 98.8273 68.271L98.8332 68.2713Z",
  fill: "url(#paint14_linear_5261_1434)"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M94.4994 70.8884L91.6031 70.7739C91.6916 71.363 91.8677 71.821 92.139 72.1011C92.4104 72.3813 92.7733 72.5772 93.2316 72.5953C93.6898 72.6134 94.0382 72.4339 94.2303 72.1896C94.4221 71.9512 94.5177 71.4689 94.4938 70.8823L94.4994 70.8884Z",
  fill: "url(#paint15_linear_5261_1434)"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M97.2576 82.2349C90.218 81.8454 83.5017 76.8476 82.3225 69.9133C81.1711 63.1676 87.4891 58.2926 93.9828 58.6489C101.023 59.0326 107.715 64.0353 108.901 70.964C110.058 77.7099 103.751 82.5912 97.2576 82.2349Z",
  fill: "url(#paint16_linear_5261_1434)"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3839 47.775C96.3804 46.0764 95.0661 44.6422 93.3624 44.5749C91.6587 44.5075 90.212 45.8267 90.2094 47.5309C90.2128 49.2295 91.6566 50.663 93.3603 50.7303C95.0641 50.7977 96.3874 49.4736 96.3839 47.775Z",
  fill: "url(#paint17_linear_5261_1434)"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M101.072 93.3513C101.063 91.6524 99.6135 90.2188 97.9039 90.1512C96.1943 90.0836 94.8827 91.4081 94.898 93.1072C94.9073 94.8061 96.2333 96.2407 97.9371 96.308C99.6408 96.3754 101.082 95.056 101.067 93.3511L101.072 93.3513Z",
  fill: "url(#paint18_linear_5261_1434)"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M91.6316 61.7151L97.8003 61.959L97.6956 64.608C97.6803 64.9939 97.5787 65.3325 97.3906 65.6238C97.2024 65.9209 96.952 66.1512 96.6396 66.3145C96.3269 66.4837 95.9797 66.5608 95.5978 66.5457C95.1983 66.5299 94.8435 66.4251 94.5334 66.2313C94.229 66.0435 93.9917 65.794 93.8216 65.4827C93.6513 65.1773 93.5738 64.8316 93.589 64.4457L93.6348 63.2878L91.5727 63.2063L91.6316 61.7151ZM94.9489 63.3134L94.9104 64.287C94.9053 64.4157 94.933 64.5339 94.9934 64.6417C95.0539 64.7495 95.1387 64.8378 95.2478 64.9066C95.3568 64.9753 95.4848 65.0126 95.6317 65.0184C95.7844 65.0244 95.915 64.9974 96.0233 64.9372C96.1315 64.8771 96.2171 64.7955 96.2801 64.6926C96.343 64.5897 96.377 64.4739 96.382 64.3452L96.4205 63.3716L94.9489 63.3134Z",
  fill: "white"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M91.409 67.3474L97.5776 67.5913L97.5187 69.0824L92.6719 68.8908L92.5637 71.6276L91.2419 71.5753L91.409 67.3474Z",
  fill: "white"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M91.2046 72.5171L97.3733 72.761L97.3206 74.0943L92.7872 77.1392L92.8427 76.8515C93.0377 76.8299 93.2237 76.8139 93.4006 76.8033C93.5775 76.7927 93.7516 76.782 93.9226 76.7712C94.0935 76.7663 94.2672 76.7614 94.4439 76.7567C94.6204 76.7578 94.8116 76.7595 95.0174 76.7618C95.2231 76.7699 95.4463 76.7787 95.6872 76.7883L97.2117 76.8485L97.1545 78.2958L90.9858 78.052L91.0392 76.7012L95.7192 73.5214L95.6399 73.9663C95.3567 73.9844 95.1149 73.9983 94.9145 74.0079C94.7197 74.0237 94.5457 74.0344 94.3925 74.04C94.239 74.0515 94.1005 74.0578 93.9769 74.0587C93.8533 74.0597 93.7298 74.0577 93.6064 74.0529C93.4887 74.0541 93.3564 74.0518 93.2095 74.046L91.1474 73.9644L91.2046 72.5171Z",
  fill: "white"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9725 82.8623C41.4436 75.474 53.5567 75.474 61.0277 82.8623C68.4987 90.2507 68.4987 102.23 61.0277 109.618C53.5567 117.007 41.4436 117.006 33.9725 109.618C26.5014 102.23 26.5014 90.2507 33.9725 82.8623Z",
  fill: "#F28A2A",
  stroke: "white",
  strokeWidth: 5
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M37.6355 87.9289C35.5161 82.809 29.7251 84.1523 29.7251 88.8883C29.7251 94.425 37.6355 98.0412 37.6355 98.0412C37.6355 98.0412 45.5459 94.425 45.5459 88.8883C45.5459 84.1523 39.7549 82.8074 37.6355 87.9289Z",
  fill: "#5F1341"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M57.3621 87.9289C59.4814 82.809 65.2724 84.1523 65.2724 88.8883C65.2724 94.425 57.3621 98.0412 57.3621 98.0412C57.3621 98.0412 49.4517 94.425 49.4517 88.8883C49.4517 84.1523 55.2427 82.8074 57.3621 87.9289Z",
  fill: "#5F1341"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M56.4186 102.084C55.3664 103.788 53.8225 105.166 51.9791 106.026C50.6225 106.663 49.1037 107.017 47.5012 107.017C45.8987 107.017 44.3782 106.663 43.0233 106.026C41.1799 105.165 39.636 103.788 38.5838 102.084C38.1556 101.391 38.5487 100.486 39.3499 100.308C39.457 100.285 39.564 100.26 39.6728 100.238C41.8858 99.7669 44.5856 99.3996 47.6601 99.4145C50.5991 99.4261 53.1902 99.7817 55.3313 100.238C55.4383 100.261 55.5454 100.285 55.6525 100.308C56.4537 100.485 56.8451 101.393 56.4186 102.084Z",
  fill: "#5F1341"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M55.3328 100.238C53.1064 100.606 50.4083 100.819 47.5011 100.819C44.5938 100.819 41.9007 100.604 39.6743 100.238C41.8874 99.7669 44.5872 99.3996 47.6617 99.4145C50.6007 99.4261 53.1917 99.7817 55.3328 100.238Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5261_1434",
  x1: 4,
  y1: 71.4926,
  x2: 139.002,
  y2: 71.4926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_5261_1434",
  x1: 20.1619,
  y1: 46.9617,
  x2: 93.7192,
  y2: 98.0087,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_5261_1434",
  x1: 56.6781,
  y1: 68.4951,
  x2: 58.0051,
  y2: 69.416,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_5261_1434",
  x1: 55.5984,
  y1: 74.9261,
  x2: 57.0456,
  y2: 75.9304,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_5261_1434",
  x1: 47.0215,
  y1: 65.8802,
  x2: 66.2798,
  y2: 79.245,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_5261_1434",
  x1: 33.6557,
  y1: 60.5186,
  x2: 38.7089,
  y2: 64.0254,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_5261_1434",
  x1: 74.6179,
  y1: 81.0552,
  x2: 79.6711,
  y2: 84.562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_5261_1434",
  x1: 60.4008,
  y1: 23.6551,
  x2: 93.9762,
  y2: 106.656,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_5261_1434",
  x1: 79.1548,
  y1: 61.6745,
  x2: 79.7605,
  y2: 63.1718,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_5261_1434",
  x1: 74.7282,
  y1: 66.4628,
  x2: 75.3888,
  y2: 68.0958,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_5261_1434",
  x1: 72.5078,
  y1: 54.1972,
  x2: 81.2983,
  y2: 75.928,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_5261_1434",
  x1: 64.2632,
  y1: 42.3879,
  x2: 66.5697,
  y2: 48.0899,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_5261_1434",
  x1: 87.2833,
  y1: 82.0088,
  x2: 89.5898,
  y2: 87.7108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_5261_1434",
  x1: 97.6037,
  y1: 25.9126,
  x2: 94.0671,
  y2: 115.378,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_5261_1434",
  x1: 99.0594,
  y1: 68.2802,
  x2: 98.9956,
  y2: 69.8942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_5261_1434",
  x1: 93.0555,
  y1: 70.8254,
  x2: 92.9859,
  y2: 72.5856,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_5261_1434",
  x1: 96.0768,
  y1: 58.7302,
  x2: 95.1509,
  y2: 82.1534,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_5261_1434",
  x1: 93.4189,
  y1: 44.5771,
  x2: 93.1759,
  y2: 50.7231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_5261_1434",
  x1: 98.105,
  y1: 90.1591,
  x2: 97.8621,
  y2: 96.3051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomClientOfferStage3MainIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom-client-offer-stage-3-main-icon.2e31ad4037e2ca3421a087e74985939b.svg";